import { FC } from "react";
import cx from "classnames";
import PricePropertyValue from "./pricePropertyValue";
import { ClientSiteData, PropertyVisualStyle, ShowIfNotSetValues } from "../../../types/site";
import { Vehicle } from "../../../types/vehicle";
import { isPriceProperty } from "../../../utils/vehicleProperties";
import { getPhoneForVehicle } from "../../../utils/ui";
import { Translations } from "../../../utils/translations";
import { ColorTypeField, getBackgroundValue, getColorType } from "../../../utils/colors";
import styles from "./vehicle-property-value-view.module.scss";

interface IVehiclePropertyValue {
  className: string;
  propertyName: string;
  propertyValue?: string;
  vehicle: Vehicle;
  siteData: ClientSiteData;
  translations: Translations;
  callToPriceClassName: string;
  visualStyle: PropertyVisualStyle;
  showIfNotSet: ShowIfNotSetValues;
  lockText?: string;
  lockTextLeftGradientColor?: string;
  lockTextRightGradientColor?: string;
}

const VehiclePropertyValue: FC<IVehiclePropertyValue> = ({
  className,
  propertyName,
  propertyValue,
  vehicle,
  siteData,
  translations,
  callToPriceClassName,
  visualStyle,
  lockText,
  lockTextLeftGradientColor,
  lockTextRightGradientColor,
  showIfNotSet,
}) => {
  if (isPriceProperty(visualStyle)) {
    return (
      <PricePropertyValue
        propertyValue={propertyValue}
        className={className}
        vehicle={vehicle}
        propertyVisualStyle={visualStyle}
        showIfNotSet={showIfNotSet}
        callToPriceClassName={callToPriceClassName}
        lockedText={lockText}
        phone={getPhoneForVehicle(siteData, vehicle)}
        translations={translations}
        lockTextLeftGradientColor={lockTextLeftGradientColor}
        lockTextRightGradientColor={lockTextRightGradientColor}
      />
    );
  }

  return (
    <div className={styles.infoValueContainer}>
      <p className={className} title={propertyValue}>
        {propertyValue}
      </p>
      {propertyName === "extColor" && vehicle.color && (
        <span
          className={styles.color}
          style={{ background: getBackgroundValue(ColorTypeField.PROPERTIES, getColorType(vehicle.color)) }}
        ></span>
      )}
      {propertyName === "intColor" && vehicle.colorInternal && (
        <span
          className={cx(styles.color, styles.circle)}
          style={{ background: getBackgroundValue(ColorTypeField.PROPERTIES, getColorType(vehicle.colorInternal)) }}
        ></span>
      )}
    </div>
  );
};

export default VehiclePropertyValue;
